import { useUnreadConversations } from '@/data/conversation';

const NotificationDotForNavigation = () => {
  const unreadConversations = useUnreadConversations();

  if (unreadConversations.isLoading || !unreadConversations.data) {
    return null;
  }

  if (Object.keys(unreadConversations.data.unreadConversations).length === 0) {
    return null;
  }

  return (
    <div className="absolute -top-1 -right-2 bg-red-500 w-3 h-3 rounded-full" />
  );
};

export default NotificationDotForNavigation;
